import { client } from '../lib/client';

export const getShortlinks = async ({
  page,
  pageSize,
  sortBy,
  desc,
  searchValue,
  shortlinkBulkUploadId,
}) => {
  const response = await client.get(
    `/api/get-shortlinks?${new URLSearchParams({
      page,
      pageSize,
      sortBy,
      desc,
      searchValue: searchValue || '',
      shortlinkBulkUploadId: shortlinkBulkUploadId || '',
    })}`,
  );
  const { shortlinks, count } = response.data.object;

  return { shortlinks, count };
};
